import {
  EngineDisplayModeType,
  EngineResultsFormatType,
  EngineBookingAdvantagesPositionType,
  EngineRoundType,
} from "../../../../gen/witbooking/backoffice/propertyconfiguration/v1/propertyconfiguration_api_pb";
import { BookAndJoinType } from "../../../../gen/witbooking/backoffice/loyalty/brand/v1/loyalty_brand_api_pb";

export const DisplayModeMapping: Record<EngineDisplayModeType, string> = {
  [EngineDisplayModeType.ENGINE_DISPLAY_MODE_TYPE_EMPTY]: "",
  [EngineDisplayModeType.SIDEBAR]: "SIDEBAR",
  [EngineDisplayModeType.EXTENDED]: "EXTENDED",
};

export const ResultsFormatTypeMapping: Record<EngineResultsFormatType, string> = {
  [EngineResultsFormatType.ENGINE_RESULTS_FORMAT_TYPE_EMPTY]: "",
  [EngineResultsFormatType.AUTO]: "AUTO",
  [EngineResultsFormatType.GRID]: "GRID",
  [EngineResultsFormatType.LIST]: "LIST",
  [EngineResultsFormatType.UNIFIED]: "UNIFIED",
};

export const BookingAdvantagesPositionMapping: Record<
  EngineBookingAdvantagesPositionType,
  string
> = {
  [EngineBookingAdvantagesPositionType.ENGINE_BOOKING_ADVANTAGES_POSITION_TYPE_EMPTY]: "",
  [EngineBookingAdvantagesPositionType.TOP]: "TOP",
  [EngineBookingAdvantagesPositionType.BOTTOM]: "BOTTOM",
};

export const BookAndJoinTypeMapping: Record<BookAndJoinType, string> = {
  [BookAndJoinType.INVALID_BOOK_AND_JOIN_TYPE]: "",
  [BookAndJoinType.DISABLED]: "DISABLED",
  [BookAndJoinType.OPT_IN]: "OPT_IN",
  [BookAndJoinType.OPT_OUT]: "OPT_OUT",
};

export const RoundTypeMapping: Record<EngineRoundType, string> = {
  [EngineRoundType.ENGINE_ROUND_TYPE_EMPTY]: "",
  [EngineRoundType.ZERO]: "ZERO",
  [EngineRoundType.DEFAULT]: "DEFAULT",
  [EngineRoundType.MD]: "MD",
  [EngineRoundType.LG]: "LG",
  [EngineRoundType.XL]: "XL",
  [EngineRoundType.XXL]: "XXL",
  [EngineRoundType.XXXL]: "XXXL",
  [EngineRoundType.FULL]: "FULL",
};
